export default __webpack_public_path__ + "static/media/hand-with-chocolate-lyte.f960f52e.png";